import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ children }) => {
  const { isAuth, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return isAuth ? children : <Navigate to="/login" />;
};

export default PrivateRoute;